module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getCurrentDiscussion.enable_grading) ? _c('div', [_vm._l((_vm.studentAssessment), function(assessment, index) {
    return _c('div', {
      key: index,
      staticClass: "mx-3"
    }, [_c('LiveDiscussionPoint', {
      staticClass: "flex items-center justify-between py-2.5 border-b border-solid border-gray-200",
      attrs: {
        "assessment": assessment,
        "disabled": _vm.disabled,
        "pointCap": _vm.getCurrentDiscussion.point_cap,
        "is_summary": _vm.isSummary
      },
      on: {
        "saveAssessment": function($event) {
          return _vm.$emit('saveAssessment', $event)
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.studentAssessment.length) ? _c('div', {
    staticClass: "flex items-center justify-between mx-3 py-2.5 font-medium"
  }, [_c('span', [_vm._v("Total Points")]), _vm._v(" "), _c('span', {
    staticClass: "flex justify-center",
    class: [_vm.hasTeacherPermissionsInCourse ? 'w-20' : 'w-12']
  }, [_c('span', {
    staticClass: "flex justify-center items-center h-8 w-12 rounded border border-solid border-gray-200"
  }, [_vm._v("\n        " + _vm._s(_vm.totalPoints) + "\n      ")])])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0af0f32c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/liveDiscussionPointsBar/liveDiscussionPointsBar.vue
// module id = 1686
// module chunks = 61